import type { DirectionDxDy } from "../direction/DirectionDxDy.type"
import coord from "./coord"
import type { TilePositionXY } from "./TilePositionXY.type"

export default function getNeighborTilePosition(
  p0: TilePositionXY,
  dir: DirectionDxDy
): TilePositionXY {
  return coord(p0.x + dir.dx, p0.y + dir.dy)
}